import { AppointmentType } from "../types/appointment.definition";
import { Doctor } from "../types/doctor";

export const mockDoctors: Doctor[] = [
  {
    id: "1",
    firstName: "Dr. Aminata",
    lastName: "Sow",
    email: "sarah.johnson@medicine360.com",
    civility: "WOMAN",
    refNumber: "DOC001",
    contactPhoneNumber: "+1234567890",
    averageRate: 4.8,
    careerStartYear: "2010",
    photoUrl:
      "https://plus.unsplash.com/premium_photo-1661690896275-1fd02092fee1?q=80&w=2070&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
    specialties: [
      { id: 1, code: "CARDIOLOGY", label: "Cardiology" },
      { id: 2, code: "INTERNAL_MEDICINE", label: "Internal Medicine" },
    ],
    rating: 4.8,
    reviews: 127,
    consultationFee: 150,
    nextAvailable: "Tomorrow",
    languages: ["English", "Spanish"],
    experience: 12,
    insuranceAccepted: ["Blue Cross", "Aetna", "Cigna"],
    providedServices: [
      { code: AppointmentType.CLINIC, price: 150 },
      { code: AppointmentType.CLINIC, price: 100 },
    ],
    location: {
      address: "123 Medical Ave",
      city: "New York",
      state: "NY",
      zipCode: "10001",
    },
    biography: "Experienced cardiologist with focus on preventive care",
    education: ["MD - Johns Hopkins", "Cardiology Fellowship - Mayo Clinic"],
    availableDays: ["Monday", "Wednesday", "Friday"],
    preferredNotificationMethods: ["EMAIL", "SMS"],
    dateOfBirth: "1980-01-01",
    roleName: "DOCTOR",
    healthcareFacilities: [
      {
        id: 1,
        name: "New York Medical Center",
        address: "123 Medical Ave, New York, NY 10001",
      },
    ],
  },
  {
    id: "2",
    firstName: "Dr. Jean Paul",
    lastName: "Sène",
    email: "michael.chen@medicine360.com",
    civility: "MAN",
    refNumber: "DOC002",
    averageRate: 4.9,
    careerStartYear: "2010",
    contactPhoneNumber: "+1234567891",
    photoUrl:
      "https://plus.unsplash.com/premium_photo-1661578805804-2e12c004931e?q=80&w=2070&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
    specialties: [{ id: 3, code: "PEDIATRIC", label: "Pediatrics" }],
    rating: 4.9,
    reviews: 208,
    consultationFee: 130,
    nextAvailable: "Today",
    languages: ["English", "Mandarin"],
    experience: 15,
    insuranceAccepted: ["United Healthcare", "Kaiser", "Anthem"],
    providedServices: [
      { code: AppointmentType.CLINIC, price: 130 },
      { code: AppointmentType.HOME, price: 180 },
    ],
    location: {
      address: "456 Health St",
      city: "San Francisco",
      state: "CA",
      zipCode: "94105",
    },
    biography: "Pediatric specialist with focus on early childhood development",
    education: ["MD - Stanford", "Pediatrics Residency - UCSF"],
    availableDays: ["Tuesday", "Thursday", "Saturday"],
    preferredNotificationMethods: ["EMAIL", "SMS"],
    dateOfBirth: "1980-01-01",
    roleName: "DOCTOR",
    healthcareFacilities: [
      {
        id: 1,
        name: "New York Medical Center",
        address: "123 Medical Ave, New York, NY 10001",
      },
    ],
  },
  {
    id: "3",
    firstName: "Dr. Maimouna",
    lastName: "Ndiaye",
    email: "maimouna.ndiaye@medicine360.com",
    civility: "WOMAN",
    refNumber: "DOC003",
    contactPhoneNumber: "+1234567892",
    averageRate: 4.9,
    careerStartYear: "2010",
    photoUrl:
      "https://plus.unsplash.com/premium_photo-1661627338048-d5650cef65dd?q=80&w=2070&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
    specialties: [{ id: 3, code: "PEDIATRIC", label: "Pediatrics" }],
    rating: 4.9,
    reviews: 156,
    consultationFee: 150,
    nextAvailable: "Today",
    languages: ["English", "Spanish", "Portuguese"],
    experience: 10,
    insuranceAccepted: ["Aetna", "Humana", "Florida Blue"],
    providedServices: [
      { code: AppointmentType.CLINIC, price: 150 },
      { code: AppointmentType.ONLINE, price: 120 },
    ],
    location: {
      address: "789 Health Blvd",
      city: "Miami",
      state: "FL",
      zipCode: "33101",
    },
    biography: "Pediatric care specialist with focus on child development",
    education: ["MD - Columbia", "Pediatrics Residency - Children's Hospital"],
    availableDays: ["Monday", "Tuesday", "Thursday", "Friday"],
    preferredNotificationMethods: ["EMAIL", "SMS"],
    dateOfBirth: "1980-01-01",
    roleName: "DOCTOR",
    healthcareFacilities: [
      {
        id: 1,
        name: "New York Medical Center",
        address: "123 Medical Ave, New York, NY 10001",
      },
    ],
  },
  {
    id: "4",
    firstName: "Dr. Daouda",
    lastName: "Sène",
    email: "james.wilson@medicine360.com",
    civility: "MAN",
    refNumber: "DOC004",
    contactPhoneNumber: "+1234567893",
    averageRate: 4.7,
    careerStartYear: "2010",
    photoUrl:
      "https://images.unsplash.com/photo-1582895361887-24daa40c8667?q=80&w=2141&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
    specialties: [{ id: 4, code: "ORTHOPEDIC", label: "Orthopedic Surgeon" }],
    rating: 4.7,
    reviews: 89,
    consultationFee: 250,
    location: {
      address: "101 Medical Center Dr",
      city: "Boston",
      state: "MA",
      zipCode: "02115",
    },
    nextAvailable: "Next Week",
    languages: ["English"],
    experience: 15,
    insuranceAccepted: ["Blue Cross", "Medicare", "Harvard Pilgrim"],
    providedServices: [
      { code: AppointmentType.CLINIC, price: 250 },
      { code: AppointmentType.CLINIC, price: 200 },
    ],
    biography: "Orthopedic surgeon specializing in sports medicine",
    education: ["MD - Yale", "Orthopedic Surgery Fellowship - HSS"],
    availableDays: ["Wednesday", "Thursday", "Friday"],
    preferredNotificationMethods: ["EMAIL", "SMS"],
    dateOfBirth: "1980-01-01",
    roleName: "DOCTOR",
    healthcareFacilities: [
      {
        id: 1,
        name: "New York Medical Center",
        address: "123 Medical Ave, New York, NY 10001",
      },
    ],
  },
  {
    id: "5",
    firstName: "Dr. Aisha",
    lastName: "Patel",
    email: "aisha.patel@medicine360.com",
    civility: "WOMAN",
    refNumber: "DOC005",
    contactPhoneNumber: "+1234567894",
    averageRate: 4.9,
    careerStartYear: "2010",
    photoUrl:
      "https://plus.unsplash.com/premium_photo-1661693636694-4127451529c6?q=80&w=2070&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
    specialties: [{ id: 5, code: "NEUROLOGIST", label: "Neurologist" }],
    rating: 4.9,
    reviews: 112,
    consultationFee: 225,
    nextAvailable: "Tomorrow",
    languages: ["English", "Hindi", "Gujarati"],
    experience: 11,
    insuranceAccepted: ["Blue Cross", "UnitedHealth", "Medicare"],
    providedServices: [
      { code: AppointmentType.CLINIC, price: 225 },
      { code: AppointmentType.CLINIC, price: 175 },
    ],
    location: {
      address: "202 Neuro Way",
      city: "Chicago",
      state: "IL",
      zipCode: "60601",
    },
    biography: "Neurologist with expertise in headache disorders",
    education: ["MBBS - Oxford", "Neurology Fellowship - Cleveland Clinic"],
    availableDays: ["Monday", "Wednesday", "Friday"],
    preferredNotificationMethods: ["EMAIL", "SMS"],
    dateOfBirth: "1980-01-01",
    roleName: "DOCTOR",
    healthcareFacilities: [
      {
        id: 1,
        name: "New York Medical Center",
        address: "123 Medical Ave, New York, NY 10001",
      },
    ],
  },
];
